import '../styles/app.scss';

window.easings = {};
window.easings.ease = 'cubicBezier(0.25, 0.46, 0.45, 0.94)';
window.easings.andrew = 'cubicBezier(0.77, 0, 0.175, 1)';
window.easings.feebles1 = 'cubicBezier(.8,.03,.25,1)';
window.easings.feebles2 = 'cubicBezier(.72,.01,.25,1)';
window.easings.ease2 = 'cubicBezier(.48,.1,.48,.9)';

// Getting our breakpoint for javascript
window.Breakpoint = {};

Breakpoint.refreshValue = function() {
  this.value = window
    .getComputedStyle(document.querySelector('body'), ':before')
    .getPropertyValue('content')
    .replace(/\"/g, '');
};

$(window)
  .resize(function() {
    Breakpoint.refreshValue();
  })
  .resize();

// Libs
import PubSub from 'underpub-js';
import Sitewide from './classes/Sitewide';
import ComponentsLoader from './classes/ComponentsLoader';

// Components Import -- DO NOT REMOVE COMMENT!
import Loader from "../components/molecules/Global/Loader/Loader";
import SideNavigation from '../components/layouts/SideNavigation/SideNavigation';
import Pagination from '../components/elements/Pagination/Pagination';
import ListingProjects from '../components/molecules/Listings/ListingProjects/ListingProjects';
import ListingPeople from '../components/molecules/Listings/ListingPeople/ListingPeople';
import SearchContainerContent from '../components/elements/Search/SearchContainer/SearchContainerContent/SearchContainerContent';
import SearchContainerSidebar from '../components/elements/Search/SearchContainer/SearchContainerSidebar/SearchContainerSidebar';
import SearchHeader from '../components/molecules/Search/SearchHeader/SearchHeader';
import SearchForm from '../components/elements/Search/SearchForm/SearchForm';
import SearchGroup from '../components/elements/Search/SearchGroup/SearchGroup';
import SearchContainer from '../components/molecules/Search/SearchContainer/SearchContainer';
import ImageSideCaption from '../components/molecules/ImageSideCaption/ImageSideCaption';
import InsightAuthor from '../components/elements/Insight/InsightAuthor/InsightAuthor';
import InsightContainerContent from '../components/elements/Insight/InsightContainer/InsightContainerContent/InsightContainerContent';
import InsightContainerSidebar from '../components/elements/Insight/InsightContainer/InsightContainerSidebar/InsightContainerSidebar';
import InsightContainer from '../components/molecules/Insight/InsightContainer/InsightContainer';
import HiddenImage from '../components/atoms/HiddenImage/HiddenImage';
import Form from '../components/elements/Form/Form';
import LocationDetails from '../components/elements/LocationDetails/LocationDetails';
import LocationHighlight from '../components/molecules/LocationHighlight/LocationHighlight';
import ListingLocations from '../components/molecules/Listings/ListingLocations/ListingLocations';
import Timeline from '../components/molecules/Timeline/Timeline';
import ShareButtons from '../components/elements/ShareButtons/ShareButtons';
import ProjectInfo from '../components/molecules/Project/ProjectInfo/ProjectInfo';
import ImageCarousel from '../components/molecules/ImageCarousel/ImageCarousel';
import ButtonIcon from '../components/atoms/Buttons/ButtonIcon/ButtonIcon';
import PeopleInfo from '../components/molecules/People/PeopleInfo/PeopleInfo';
import FormBlock from '../components/molecules/FormBlock/FormBlock';
import TextWithShape from '../components/atoms/TextWithShape/TextWithShape';
import FilterMarkupMultiLevel from '../components/elements/FilterMarkups/FilterMarkupMultiLevel/FilterMarkupMultiLevel';
import FilterMarkupSingleLevel from '../components/elements/FilterMarkups/FilterMarkupSingleLevel/FilterMarkupSingleLevel';
import Filter from '../components/molecules/Filter/Filter';
import TextBlock from '../components/molecules/TextBlock/TextBlock';
import VideoBlock from '../components/molecules/VideoBlock/VideoBlock';
import ImageDuoBlock from '../components/molecules/ImageDuoBlock/ImageDuoBlock';
import ImageBlock from '../components/molecules/ImageBlock/ImageBlock';
import ContentCarousel from '../components/molecules/ContentCarousel/ContentCarousel';
import AnimatedTextReveal from '../components/atoms/AnimatedText/AnimatedTextReveal/AnimatedTextReveal';
import AnimatedTextDash from '../components/atoms/AnimatedText/AnimatedTextDash/AnimatedTextDash';
import Header from '../components/molecules/Global/Header/Header';
import Footer from '../components/molecules/Global/Footer/Footer';
import HeroComplex from '../components/molecules/Heros/HeroComplex/HeroComplex';
import HeroStandard from '../components/molecules/Heros/HeroStandard/HeroStandard';
import Breadcrumbs from '../components/molecules/Breadcrumbs/Breadcrumbs';
import HeroBasic from '../components/molecules/Heros/HeroBasic/HeroBasic';
import Callout from '../components/molecules/Callout/Callout';
import ImageHighlight from '../components/molecules/ImageHighlight/ImageHighlight';
import CallToAction from '../components/molecules/CallToAction/CallToAction';
import Snippet from '../components/molecules/Snippet/Snippet';
import Intro from '../components/molecules/Intro/Intro';
import ContentBlock from '../components/molecules/ContentBlock/ContentBlock';
import InfoBlock from '../components/elements/InfoBlock/InfoBlock';
import ListingInfoBlocks from '../components/molecules/Listings/ListingInfoBlocks/ListingInfoBlocks';
import ListingFeatures from '../components/molecules/Listings/ListingFeatures/ListingFeatures';
import CardFeature from '../components/elements/Cards/CardFeature/CardFeature';
import ListingInsightsFeatured from '../components/molecules/Listings/ListingInsightsFeatured/ListingInsightsFeatured';
import ListingInsights from '../components/molecules/Listings/ListingInsights/ListingInsights';
import ListingCardFour from '../components/molecules/Listings/ListingCardFour/ListingCardFour';
import ListingCardTwo from '../components/molecules/Listings/ListingCardTwo/ListingCardTwo';
import ListingCardOne from '../components/molecules/Listings/ListingCardOne/ListingCardOne';
import SectionHeader from '../components/elements/SectionHeader/SectionHeader';
import ButtonSecondary from '../components/atoms/Buttons/ButtonSecondary/ButtonSecondary';
import ButtonPrimary from '../components/atoms/Buttons/ButtonPrimary/ButtonPrimary';
import CardLocation from '../components/elements/Cards/CardLocation/CardLocation';
import CardFour from '../components/elements/Cards/CardFour/CardFour';
import CardThree from '../components/elements/Cards/CardThree/CardThree';
import CardTwo from '../components/elements/Cards/CardTwo/CardTwo';
import CardOne from '../components/elements/Cards/CardOne/CardOne';

$(document).ready(function() {
  var components = [
    // Components Loader -- DO NOT REMOVE COMMENT!
{handle: ".comp-Loader", require: Loader },
    { handle: '.layout-SideNavigation', require: SideNavigation },
    { handle: '.el-Pagination', require: Pagination },
    { handle: '.comp-ListingProjects', require: ListingProjects },
    { handle: '.comp-ListingPeople', require: ListingPeople },
    { handle: '.el-SearchContainerContent', require: SearchContainerContent },
    { handle: '.el-SearchContainerSidebar', require: SearchContainerSidebar },
    { handle: '.comp-SearchHeader', require: SearchHeader },
    { handle: '.el-SearchForm', require: SearchForm },
    { handle: '.el-SearchGroup', require: SearchGroup },
    { handle: '.comp-SearchContainer', require: SearchContainer },
    { handle: '.comp-ImageSideCaption', require: ImageSideCaption },
    { handle: '.el-InsightAuthor', require: InsightAuthor },
    { handle: '.el-InsightContainerContent', require: InsightContainerContent },
    { handle: '.el-InsightContainerSidebar', require: InsightContainerSidebar },
    { handle: '.comp-InsightContainer', require: InsightContainer },
    { handle: '.atom-HiddenImage', require: HiddenImage },
    { handle: '.el-Form', require: Form },
    { handle: '.el-LocationDetails', require: LocationDetails },
    { handle: '.comp-LocationHighlight', require: LocationHighlight },
    { handle: '.comp-ListingLocations', require: ListingLocations },
    { handle: '.comp-Timeline', require: Timeline },
    { handle: '.el-ShareButtons', require: ShareButtons },
    { handle: '.comp-ProjectInfo', require: ProjectInfo },
    { handle: '.comp-ImageCarousel', require: ImageCarousel },
    { handle: '.atom-ButtonIcon', require: ButtonIcon },
    { handle: '.comp-PeopleInfo', require: PeopleInfo },
    { handle: '.comp-FormBlock', require: FormBlock },
    { handle: '.atom-TextWithShape', require: TextWithShape },
    { handle: '.el-FilterMarkupMultiLevel', require: FilterMarkupMultiLevel },
    { handle: '.el-FilterMarkupSingleLevel', require: FilterMarkupSingleLevel },
    { handle: '.comp-Filter', require: Filter },
    { handle: '.comp-TextBlock', require: TextBlock },
    { handle: '.comp-VideoBlock', require: VideoBlock },
    { handle: '.comp-ImageDuoBlock', require: ImageDuoBlock },
    { handle: '.comp-ImageBlock', require: ImageBlock },
    { handle: '.comp-ContentCarousel', require: ContentCarousel },
    { handle: '.atom-AnimatedTextReveal', require: AnimatedTextReveal },
    { handle: '.atom-AnimatedTextDash', require: AnimatedTextDash },
    { handle: '.comp-Header', require: Header },
    { handle: '.comp-Footer', require: Footer },
    { handle: '.comp-HeroComplex', require: HeroComplex },
    { handle: '.comp-HeroStandard', require: HeroStandard },
    { handle: '.comp-Breadcrumbs', require: Breadcrumbs },
    { handle: '.comp-HeroBasic', require: HeroBasic },
    { handle: '.comp-Callout', require: Callout },
    { handle: '.comp-ImageHighlight', require: ImageHighlight },
    { handle: '.comp-CallToAction', require: CallToAction },
    { handle: '.comp-Snippet', require: Snippet },
    { handle: '.comp-Intro', require: Intro },
    { handle: '.comp-ContentBlock', require: ContentBlock },
    { handle: '.el-InfoBlock', require: InfoBlock },
    { handle: '.comp-ListingInfoBlocks', require: ListingInfoBlocks },
    { handle: '.comp-ListingFeatures', require: ListingFeatures },
    { handle: '.el-CardFeature', require: CardFeature },
    {
      handle: '.comp-ListingInsightsFeatured',
      require: ListingInsightsFeatured,
    },
    { handle: '.comp-ListingInsights', require: ListingInsights },
    { handle: '.comp-ListingCardFour', require: ListingCardFour },
    { handle: '.comp-ListingCardTwo', require: ListingCardTwo },
    { handle: '.comp-ListingCardOne', require: ListingCardOne },
    { handle: '.el-SectionHeader', require: SectionHeader },
    { handle: '.atom-ButtonSecondary', require: ButtonSecondary },
    { handle: '.atom-ButtonPrimary', require: ButtonPrimary },
    { handle: '.el-CardLocation', require: CardLocation },
    { handle: '.el-CardFour', require: CardFour },
    { handle: '.el-CardThree', require: CardThree },
    { handle: '.el-CardTwo', require: CardTwo },
    { handle: '.el-CardOne', require: CardOne },
  ];

  var sitewide = new Sitewide();
  sitewide.init();

  // Getting our components loading going
  var componentsLoader = new ComponentsLoader({ components: components });
  componentsLoader.initScreen();

  // setting our breakpoint value
  Breakpoint.refreshValue();
});
